import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { useEditAssetGroupSubmit } from '../../hooks'
import { getSquareImageData } from '../HeadlinesSection/helpers'
import { isAllImageAssetsReady } from '../../helpers'

import EditForm from '../../../../../../../features/components/Forms/EditForm'
import MultipleGoogleMediaUpload from '../../../GoogleAssetGroupCreate/GoogleAssetGroupForm/GoogleAssetGroupMainForm/MultipleGoogleMediaUpload'

import { selectedGoogleAdAccountSelector } from '../../../../../../../modules/selectors/adAccounts'

import { googleAssetFieldType } from '../../../../../../../constants/ads'
import { getInitialValues } from './fields'
import { SQUARE_IMAGE, squareImageHeight, squareImageWidth } from '../../../../fields'
import { squareImageValidationSchema } from '../../../../validations'
import { validationSchema } from './validation'

const SquareImageSectionForm = ({ editItemData, isInternalAssetGroup, title, ...formProps }) => {
  const { assets, id: assetGroupId, account } = editItemData

  const { id: selectedAdAccountId } = useSelector(selectedGoogleAdAccountSelector)
  const adAccount = account || selectedAdAccountId

  const originalSquareImageAssets = useMemo(() => getSquareImageData(assets), [assets])

  const initialValues = useMemo(() => getInitialValues(originalSquareImageAssets), [originalSquareImageAssets])

  const { purifiedFormik, onClearSubmit, isLoadingSelector, errorSelector, successSubmit } = useEditAssetGroupSubmit({
    originalSectionAssets: originalSquareImageAssets,
    fieldType: googleAssetFieldType.SQUARE_MARKETING_IMAGE,
    sectionValueKey: SQUARE_IMAGE,
    assetGroupId,
    isInternalAssetGroup,
    initialValues,
    validationSchema,
    title,
    adAccount
  })

  const { values } = purifiedFormik

  const isImagesReady = isAllImageAssetsReady(values, SQUARE_IMAGE)

  const isEmptyList = !values[SQUARE_IMAGE].length

  return (
    <EditForm
      formik={purifiedFormik}
      initialValues={initialValues}
      isLoadingSelector={isLoadingSelector}
      errorSelector={errorSelector}
      successSubmit={successSubmit}
      clearEditItem={onClearSubmit}
      submitBtnDisabled={!isImagesReady}
      {...formProps}
    >
      <MultipleGoogleMediaUpload
        formik={purifiedFormik}
        FileItemPath={SQUARE_IMAGE}
        validationSchema={squareImageValidationSchema}
        addAnotherButtonText={isEmptyList ? 'Add square image' : 'Add another square image'}
        width={squareImageWidth}
        height={squareImageHeight}
      />
    </EditForm>
  )
}

export default SquareImageSectionForm
